import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { FixedWidthTileCarousel } from "~/common/components/carousel/FixedWidthTileCarousel";
import type { NavigationNode } from "~/Header/types";
import type { NodeResponse } from "./ChildCategoryNavigation";

import classes from "./ChildCategoryNavigation.module.less";

export const ChildCategoryNavigationCarousel = ({ category }: { category: NodeResponse }) => {
  const { t } = useTranslation();

  return (
    <FixedWidthTileCarousel gap={24} itemWidth={168} items={category.childNodes}>
      {(node: NavigationNode) => (
        <div
          className={classes.product}
          style={{ width: `${168}px` }}
          tracking-aux-sub-category-name={t(node.title, { lng: "en" })}
          tracking-aux-sub-category-url={node.url}
        >
          <a className={classNames(classes.navigation, "scha__lc__card scha__lc__card--has-hover")} href={node.url}>
            <div className={classes.imageContainer}>
              <div className={classNames(classes.image, "scha__center-content-container")}>
                <img src={node.bigImage?.url ?? category?.parentNode?.bigImage?.url} />
              </div>
            </div>
            <div className={classes.title}>
              <p>{t(node.title)}</p>
            </div>
          </a>
        </div>
      )}
    </FixedWidthTileCarousel>
  );
};
